import React from 'react';

import type { ItemContainerProps } from './radix-styled-components';
import { ItemContainer } from './radix-styled-components';
import type { ItemBaseProps } from './ItemBase';
import { ItemBase } from './ItemBase';

export type ItemProps = ItemBaseProps & ItemContainerProps;

export const Item = ({
  tone,
  startElement,
  endElement,
  children,
  data,
  ...props
}: ItemProps) => {
  /**
   * `asChild` hands the menu-item role, roving focus, typeahead and selection
   * handling to the consumer's own element, for rows whose markup ItemBase
   * cannot express — a custom link component, a grid row, or a row carrying its
   * own controls. The container's styles are skipped along with ItemBase (they
   * begin with `all: unset`, which would erase the child's own styling).
   */
  if (props.asChild) {
    return (
      <ItemContainer {...props} data={data}>
        {children}
      </ItemContainer>
    );
  }

  return (
    <ItemContainer {...props} data={data}>
      <ItemBase
        endElement={endElement}
        startElement={startElement}
        tone={tone}
        {...props}
      >
        {children}
      </ItemBase>
    </ItemContainer>
  );
};
